module.exports = __webpack_public_path__ + "img/black_and_gold.36ba81f.svg";